import { Timeline } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import IMAGES from '@/assets/images';
import CustomImage from '@/components/CustomImage';
import useAuth from '@/hooks/useAuth';
import AuthLayout, {
  TimelineContent,
  TimelineIcon,
} from '@/layouts/AuthLayout';
import BasicInfo from './_components/BasicInfo';
import PlanInfo from './_components/PlanInfo';
import BasicInfoIcon from './_icons/BasicInfoIcon';
import PlanInfoIcon from './_icons/PlanInfoIcon';

const SelfOnboard2 = () => {
  const navigate = useNavigate();
  const { verifiedInfo } = useAuth();
  const [params, setParams] = useSearchParams();
  const currentStep = Number(params.get('step'));

  const [current, setCurrent] = useState(1);

  const items = [
    {
      dot: <TimelineIcon isActive={current >= 1} Icon={BasicInfoIcon} />,
      children: (
        <TimelineContent
          title="Basic Info"
          subtitle="Company Basic information"
        />
      ),
    },
    {
      dot: <TimelineIcon isActive={current >= 2} Icon={PlanInfoIcon} />,
      children: (
        <TimelineContent title="Subscriptions" subtitle="Select Plan" />
      ),
    },
  ];

  useEffect(() => {
    if (!verifiedInfo) {
      navigate('/login', { replace: true });
    }
    // if (currentStep === 1 || currentStep === 2) {
    //   setCurrent(currentStep);
    // }
    params.delete('step');
    setParams(params);
  }, [currentStep, params, setParams, verifiedInfo, navigate]);

  return (
    <AuthLayout
      leftContent={
        <>
          <div className="mt-2 w-full flex justify-center z-10">
            <CustomImage
              alt="main_logo"
              src={IMAGES.mainLogo}
              className="w-40 h-24"
            />
          </div>
          <Timeline className="onboard-timeline z-10" items={items} />
        </>
      }
    >
      {current === 1 && <BasicInfo onNext={() => setCurrent(2)} />}
      {current === 2 && <PlanInfo onBack={() => setCurrent(1)} />}
    </AuthLayout>
  );
};

export default SelfOnboard2;
